/* In tem LOT hàng loạt (18/09/2026, 0088): phiếu tồn đầu kỳ, phiếu nhập kho, trang tồn kho của sản phẩm. */
export const lotLabelsEn = {
  lotLabels: {
    button: "Print lot labels ({{count}})",
    title: "Lot labels",
    intro: "One label per lot: product code, description, lot number and a barcode the warehouse scanner reads (item code + lot, or the lot alone when the label is too narrow).",
    copies: "Labels per lot",
    total: "{{lots}} lots · {{labels}} labels",
    invalidCopies: "Enter a whole number from 1 to 99 labels per lot.",
    barcodeTooWide: "The lot barcode does not fit the label size in Settings. Choose a wider label (for example 70×50 mm) before printing.",
    unreadable: "Lot {{lots}} has characters a scanner cannot read: the label shows the lot number but no barcode.",
    print: "Print labels",
    printError: "Could not prepare the labels for printing.",
  },
};
export const lotLabelsVi = {
  lotLabels: {
    button: "In tem lô ({{count}})",
    title: "Tem lô",
    intro: "Mỗi lô một tem: mã sản phẩm, mô tả, số lô và mã vạch để máy quét kho đọc (mã hàng + số lô; tem hẹp thì chỉ số lô).",
    copies: "Số tem mỗi lô",
    total: "{{lots}} lô · {{labels}} tem",
    invalidCopies: "Nhập số nguyên từ 1 đến 99 tem cho mỗi lô.",
    barcodeTooWide: "Mã vạch số lô không vừa khổ tem trong Cài đặt. Chọn khổ tem rộng hơn (ví dụ 70×50 mm) rồi in.",
    unreadable: "Lô {{lots}} có ký tự máy quét không đọc được: tem in số lô bằng chữ nhưng không có mã vạch.",
    print: "In tem",
    printError: "Không chuẩn bị được tem để in.",
  },
};
export const lotLabelsZh = {
  lotLabels: {
    button: "打印批次标签（{{count}}）",
    title: "批次标签",
    intro: "每个批次一张标签：产品代码、描述、批号，以及仓库扫描枪可读取的条码（品号＋批号；标签过窄时仅批号）。",
    copies: "每批次标签数",
    total: "{{lots}} 个批次 · {{labels}} 张标签",
    invalidCopies: "请输入 1 至 99 的整数。",
    barcodeTooWide: "批号条码超出设置中的标签宽度。请改用较宽的标签（例如 70×50 mm）再打印。",
    unreadable: "批次 {{lots}} 含扫描枪无法读取的字符：标签会打印批号文字，但没有条码。",
    print: "打印标签",
    printError: "无法准备打印的标签。",
  },
};
